import { useIntl } from 'react-intl'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'

function PerfectForGroupsLabel() {
  const intl = useIntl()

  return (
    <StructureLabel
      variant="standard"
      startIcon={<LineUsersAltIcon />}
    >
      {intl.formatMessage({
        id: 'ipyD-wIT-JeGQztu1sor',
        defaultMessage: 'Perfect for groups',
      })}
    </StructureLabel>
  )
}

export default PerfectForGroupsLabel
